const {dateTimeFormatter} = require('@homeaway/hacommons-i18n');

const MILLISECONDS_IN_A_DAY = 24 * 60 * 60 * 1000;
const SHORT_DATE_FORMAT = 'short';
const LONG_DATE_FORMAT = 'long';

// Eg: "en_US_HA" => es-us
const getLocale = (fullLocale) => fullLocale.substring(0, 5).replace('_', '-');

const defaultDateTimeOptions = {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
};

const getLocalizedDate = (date, isolocale, type) => {
    const dateTimeOptions = {
        date,
        locale: isolocale,
        ...defaultDateTimeOptions,
    };
    if (type === 'long') {
        dateTimeOptions.year = 'numeric';
    }
    return dateTimeFormatter.formatDateTime(dateTimeOptions);
};

// Date string of type '2020-10-10' (yyyy-MM-dd)
const getDaysFromCurrentDate = (date) => {
    if (!(date instanceof Date)) {
        date = new Date(date);
    }
    /* Before comparing, setting the dates to start of the day */
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    const refDate = new Date();
    refDate.setHours(0);
    refDate.setMinutes(0);
    refDate.setSeconds(0);
    refDate.setMilliseconds(0);
    const milliSecondsDifference = date.getTime() - refDate.getTime();

    return Math.floor(milliSecondsDifference / MILLISECONDS_IN_A_DAY);
};

const getDisplayDateRange = (startDateISO = '', endDateISO = '', locale) => {
    if (!startDateISO || !endDateISO) {
        return '';
    }
    let startDate = new Date(startDateISO);
    let endDate = new Date(endDateISO);

    const monthDayOption = {
        day: 'numeric',
        locale,
        month: 'short',
        weekday: 'short',
    };
    const startMonthDayYearOption = Object.assign(
        {date: startDate.toISOString().split('T')[0]},
        monthDayOption
    );
    const endMonthDayYearOption = Object.assign(
        {date: endDate.toISOString().split('T')[0]},
        monthDayOption,
        {year: 'numeric'}
    );
    const dateStr = `${dateTimeFormatter.formatDateTime(
        startMonthDayYearOption
    )} - ${dateTimeFormatter.formatDateTime(endMonthDayYearOption)}`;
    return dateStr;
};

module.exports = {
    getDaysFromCurrentDate,
    getDisplayDateRange,
    getLocalizedDate,
    getLocale,
    LONG_DATE_FORMAT,
    SHORT_DATE_FORMAT,
};
